module.exports = __webpack_public_path__ + "img/list04.da74fd5a.jpg";